import { Model } from '@vuex-orm/core';

export class Region extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'regions';

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default Region;
